<template>
  <div class="container-fluid container-boxed mt-3">
    <div class="card">
      <div class="card-body text-center">
        Your download will start automatically.<br/>
        <ladda-button class="btn btn-outline-info btn-sm mt-3" :click="download" v-if="ready">Download Again</ladda-button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from 'utils'
import { agencyMethods } from 'vx/helpers'

export default {
  props: {
    agencyId: {
      required: true,
      type: Number
    },
    placementId: {
      required: true,
      type: Number
    }
  },

  data () {
    return {
      ready: false
    }
  },

  async created () {
    await this.download()
  },

  methods: {
    ...agencyMethods,

    async download () {
      try {
        await this.getAgency(this.agencyId)

        this.ready = true

        window.location = apiUrl(`agencies/${this.agencyId}/placements/${this.placementId}/pdp`)
      } catch (error) {
        //
      }
    }
  }
}
</script>
